import { jsx as _jsx } from "react/jsx-runtime";
import { TableCellTextStyleClass } from './TableCellTextStyle';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
export const TableCellText = ({ text, style, background, disabled }) => {
    const className = [
        'table-cell-text',
        style ? TableCellTextStyleClass[style] : '',
        background,
        disabled ? 'disabled' : ''
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Typography, { className: className, level: TypographyLevel.BodyMd, noWrap: true, children: text }));
};
